import React, { useState, useContext, useEffect } from 'react';
import { Modal, Button, Table } from 'react-bootstrap';
import AppContext from 'context/Context';

const RawMaterialHelpModal = props => {
  const {
    config: { isDark }
  } = useContext(AppContext);

  const { modalShow, setModalShow } = props || {};

  const handleClose = () => {
    setModalShow(!modalShow);
  };

  return (
    <Modal
      show={modalShow}
      onHide={handleClose}
      backdrop="static"
      size="xl"
      centered
    >
      <Modal.Header
        closeButton
        closeVariant={isDark ? 'white' : undefined}
        className="px-card border-bottom-0"
      >
        <Modal.Title></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table bordered className="fs--1 text-center mb-0 h-100">
          <tbody className="align-middle">
            <tr>
              <th className="bg-200 text-700 border-300 w-25 border-y">
                자체검증
              </th>
              <td>조단백질, 조지방, 조섬유, 회분, 수분, 칼슘, 인</td>
            </tr>
            <tr>
              <th className="bg-200 text-700 border-300 w-25 border-y">
                외부검증
              </th>
              <td>ㅡ</td>
            </tr>
            <tr>
              <th className="bg-200 text-700 border-300 w-25 border-y">
                모니터링
              </th>
              <td>
                Aflatoxin, Ochratoxin, 납, 카드뮴, 비소, 수은, 불소, 셀레늄,
                살모넬라
              </td>
            </tr>
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer className="px-card border-top-0 align-items-center justify-content-center">
        <Button variant="secondary" onClick={handleClose}>
          닫기
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RawMaterialHelpModal;
